import { Component, OnInit, ViewContainerRef, QueryList, ViewChildren, ComponentFactoryResolver, EventEmitter, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BreadCrumbsService } from '@services/bread-crumbs/bread-crumbs.service';
import { SplitAreaDirective } from 'angular-split';
import { FormRouteController } from '../../controllers/FormRouteController';
import { NestedNavigationService } from '../../../services/nested-navigation/nested-navigation.service';
import { IEntityOptions } from '../../interfaces/IEntity';
import { ToolbarActionsService } from '../../../services/toolbar-actions/toolbar-actions.service';
import { SharedFiltersService } from '../../../services/shared-filters/shared-filters.service';

export interface IBladeForm {
  displayName: string;
  component: any;
  index: number;
  width?: number;
  hideClose?: boolean;
  showOnlyIfIdInUrl?: boolean;
  originalWidth?: number;
  autoMinimise?: boolean;
  minimiseWhenLowerThanIndex?: number;
  entityOptions?: IEntityOptions;
  formOnly?: boolean;
  panelClass?: any;
  isAutoNavOption?: boolean;
  hideSideMenu?: boolean;
  loadFormWithoutParams?: boolean;
}


export interface IHeaderSetup {
  title?: string,
  iconUrl?: string
}

export interface IBladeFormsSetup {
  forms: Array<IBladeForm>,
  header?: IHeaderSetup
  switchBreadCrumbsWithoutNavigating?: boolean;
}

@Component({
  selector: 'app-mf-panel-forms',
  templateUrl: './mf-panel-forms.component.html',
  styleUrls: ['./mf-panel-forms.component.css']
})
export class MfPanelFormsComponent extends FormRouteController implements OnInit {
  constructor(public ApiService: ApiService,
    public authService: IdentityAuthService,
    public router: Router,
    public route: ActivatedRoute,
    public componentFactoryResolver: ComponentFactoryResolver,
    public breadCrumbService: BreadCrumbsService,
    public nestedNavigationService: NestedNavigationService,
    public toolbarActionService?: ToolbarActionsService,
    private sharedFiltersService?: SharedFiltersService
  ) {
    super(ApiService, authService, router, route, componentFactoryResolver, breadCrumbService, nestedNavigationService, toolbarActionService);
  }
}
